export const localStorageKey = {
  token: "token",
  tokenAliveTime: "tokenAliveTime",
  tokenKeepAlive: "tokenKeepAlive",
};

export const maxIdleTimeout = 60 * 60 * 1;
export const maxTokenAliveTime = 60 * 60 * 24;

export const recordPeriod = 30;

export const tableSetting = {
  pageLimit: 10,
};

export const recentLogins = {
  LOGIN_SUCCESSFUL: "Login successful",
  SSO_LOGIN_SUCCESSFUL: "SSO Login successful",
};

export const userType = {
  cloudAdmin: "WORLD",
  sp: "SP",
  si: "SI",
  org: "ORG_MANAGER",
  siteTag: "TAG_MANAGER",
  site: "STORE_MANAGER",
};

export const userPrivilege = {
  manager: "MANAGER",
  editor: "EDITOR",
  monitor: "MONITOR",
  viewer: "VIEWER",
};

export const userPermissions = { // default ???
  manager: {
    add: {
      enable: true,
      show: true
    },
    edit: {
      enable: true,
      show: true
    },
    delete: {
      enable: true,
      show: true
    }
  },
  editor: {
    add: {
      enable: false,
      show: true
    },
    edit: {
      enable: true,
      show: true
    },
    delete: {
      enable: false,
      show: true
    }
  },
  monitor: {
    add: {
      enable: false,
      show: false
    },
    edit: {
      enable: false,
      show: false
    },
    delete: {
      enable: false,
      show: false
    }
  },
  viewer: {
    add: {
      enable: false,
      show: false
    },
    edit: {
      enable: false,
      show: false
    },
    delete: {
      enable: false,
      show: false
    }
  }
};